<template>
  <v-container ref="resourceMain">
    <div :class="$vuetify.breakpoint.mdAndUp ? 'display-1' : 'title'">
      Resources
    </div>

    <v-divider
      class="pb-3"
    />

    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-img
          class="mx-auto"
          src="@/assets/assessment/gla-360-temp.png"
          lazy-src="@/assets/assessment/gla-360-temp.png"
          aspect-ratio="1.7"
          :max-width="$vuetify.breakpoint.mdAndDown ? '600px' : ''"
        >
          <template #placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              />
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <div
          class="pb-4"
          :class="$vuetify.breakpoint.mdAndUp ? 'headline' : 'title'"
        >
          Global Leadership 360 Assessment (GLA360)
        </div>
        <div
          class="pb-2"
          :style="`font-size: ${customRem}px;`"
        >
          Here you will find resources that support the usage of the GLA360 instrument.
          You can view instructional videos,
          print worksheets including the Authentic Leadership Model,
          and access templates for analysis, action planning, and more.
        </div>
        <v-btn
          style="text-transform: unset;"
          outlined
          :block="$vuetify.breakpoint.smAndDown"
          @click="goRouter('gla')"
        >
          {{ $vuetify.breakpoint.smAndDown
            ? 'Go to GLA 360' : 'Go to Global Leadership 360 Assessment (GLA360)' }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-img
          class="mx-auto"
          src="@/assets/resources/main/scc-individual-temp.jpg"
          lazy-src="@/assets/resources/main/scc-individual-temp.jpg"
          aspect-ratio="1.7"
          :max-width="$vuetify.breakpoint.mdAndDown ? '600px' : ''"
        >
          <template #placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              />
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <div
          class="pb-4"
          :class="$vuetify.breakpoint.mdAndUp ? 'headline' : 'title'"
        >
          1 to 1 Stakeholder Centered Coaching
        </div>

        <div
          class="pb-2"
          :style="`font-size: ${customRem}px;`"
        >
          Here you will find resources that support the delivery of the
          Marshall Goldsmith Stakeholder Centered Coaching process to executive leaders.
          New videos will be added throughout the year to support you
          in helping leaders create measurable leadership change.
          You will find videos that are instructional and demonstrative for the coach
          as well as some videos you can share with your clients.
        </div>
        <v-btn
          style="text-transform: unset;"
          outlined
          :block="$vuetify.breakpoint.smAndDown"
          @click="goRouter('individual')"
        >
          {{ $vuetify.breakpoint.smAndDown
            ? 'Go to 1 to 1 Coaching' : 'Go to 1 to 1 Stakeholder Centered Coaching' }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-img
          class="mx-auto"
          src="@/assets/resources/main/scc-team-temp.jpg"
          lazy-src="@/assets/resources/main/scc-team-temp.jpg"
          aspect-ratio="1.7"
          :max-width="$vuetify.breakpoint.mdAndDown ? '600px' : ''"
        >
          <template #placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              />
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <div
          class="pb-4"
          :class="$vuetify.breakpoint.mdAndUp ? 'headline' : 'title'"
        >
          TEAM Stakeholder Centered Coaching
        </div>

        <div
          class="pb-2"
          :style="`font-size: ${customRem}px;`"
        >
          Here you will find resources that support the delivery of
          the Marshall Goldsmith TEAM Stakeholder Centered Coaching process to executive teams.
          You will find demonstration videos, coaching commentaries, and supporting content
          that will help you develop the leadership of executive teams.
        </div>
        <v-btn
          style="text-transform: unset;"
          outlined
          :block="$vuetify.breakpoint.smAndDown"
          @click="goRouter('team')"
        >
          {{ $vuetify.breakpoint.smAndDown
            ? 'Go to TEAM Coaching' : 'Go to TEAM Stakeholder Centered Coaching' }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ResourceMain',

  computed: {
    customRem() {
      return this.$vuetify.breakpoint.mdAndUp ? '17' : '16';
    },
  },

  methods: {
    goRouter(type) {
      this.$router.push({ name: 'resources', params: { type } });
    },
  },
};
</script>
